
import { getImages } from "./ProductTileImagesLegacy.shopify.gql";

export default {
  props: {
    imagesProps: { type: Object, default: () => {} },
    disableWishlistIcon: { type: Boolean, default: false },
  },

  data() {
    return { images: [this.imagesProps?.mainImage].filter(Boolean) };
  },

  async fetch() {
    if (this.imageIds.length < 1) {
      return;
    }

    const areImagesGIDs = this.imageIds.find(image =>
      image.includes("/MediaImage/")
    );

    if (areImagesGIDs) {
      const { data } = await this.$getShopifyData({
        query: getImages,
        variables: { ids: this.imageIds },
      });

      const images = (data.images ?? [])
        .filter(Boolean)
        .map(({ image }) => image);
      this.images =
        images.length === 0 ? [this.imagesProps?.mainImage] : images;
    }
  },

  fetchOnServer: false,

  computed: {
    imageIds() {
      return this.imagesProps?.metafields?.images ?? [];
    },
    carouselProps() {
      return {
        ...this.imagesProps,
        images: this.images,
      };
    },
  },
};
